<!-- ── Toolbar: search + filter + download (left) + bulk-delete + add + upload ── -->
<div class="list-preferred-products__toolbar">
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'knowledge_base.preferred_products.search_placeholder' | translate"
    class="list-preferred-products__search"
  >
  </ui-form-field>
  <div class="filter-button-group">
    <button class="action-button" (click)="setFilter()" [ngClass]="{ activeFilter: hasActiveFilters() }">
      <div class="action-button-icon">
        <img src="assets/icones/filter_icon.svg" alt="" />
      </div>
      <span class="action-button-text">{{ "knowledge_base.filter" | translate }}</span>
      <div class="clear-icon-container">
        <img
          class="clear-icon"
          *ngIf="hasActiveFilters()"
          (click)="clearFilter(); $event.stopPropagation()"
          src="assets/icones/clear-icon.svg"
          alt=""
        />
        <div class="clear-tooltip" *ngIf="hasActiveFilters()">
          {{ "common.clear_filters" | translate }}
        </div>
      </div>
    </button>
  </div>
  <ui-button [label]="'knowledge_base.download' | translate" type="secondary" icon="download_icon" (click)="exportList()"> </ui-button>
  <div class="list-preferred-products__toolbar-actions">
    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary-text-outlined"
      icon="plus-cc"
      iconSize="large"
      [label]="'knowledge_base.preferred_products.add_preferred_product' | translate"
      (click)="openCreateModal()"
    >
    </ui-button>
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary"
      icon="upload"
      [label]="'knowledge_base.upload_file' | translate"
      (click)="openImportDialog()"
    >
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-preferred-products__table" [class.list-preferred-products__table--with-bulk-bar]="selection.hasSelection">
  <!-- Header -->
  <div class="list-preferred-products__table-header">
    <div class="list-preferred-products__table-cell list-preferred-products__table-cell--checkbox" (click)="$event.stopPropagation()">
      <ui-checkbox
        [checked]="selection.isAllSelected"
        [indeterminate]="selection.isPartialSelected"
        [ariaLabel]="'common.select_all' | translate"
        (changed)="selection.toggleAll($event.checked)"
      ></ui-checkbox>
    </div>
    <div class="list-preferred-products__table-cell list-preferred-products__table-cell--sortable" (click)="onSort('customer')">
      {{ "knowledge_base.preferred_products.col.customer" | translate }}
      <div class="list-preferred-products__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'customer' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'customer' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-preferred-products__table-cell list-preferred-products__table-cell--sortable" (click)="onSort('product')">
      {{ "knowledge_base.preferred_products.col.product" | translate }}
      <div class="list-preferred-products__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'product' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'product' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-preferred-products__table-cell">
      {{ "knowledge_base.preferred_products.col.sku" | translate }}
    </div>
    <div class="list-preferred-products__table-cell list-preferred-products__table-cell--sortable" (click)="onSort('purchase_frequency')">
      {{ "knowledge_base.preferred_products.col.purchase_frequency" | translate }}
      <div class="list-preferred-products__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'purchase_frequency' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'purchase_frequency' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-preferred-products__table-cell list-preferred-products__table-cell--sortable" (click)="onSort('source')">
      {{ "knowledge_base.preferred_products.col.source" | translate }}
      <div class="list-preferred-products__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'source' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'source' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-preferred-products__table-cell list-preferred-products__table-cell--sortable" (click)="onSort('create_date')">
      {{ "knowledge_base.preferred_products.col.created_date" | translate }}
      <div class="list-preferred-products__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'create_date' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'create_date' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-preferred-products__table-cell list-preferred-products__table-cell--sortable" (click)="onSort('last_seen_date')">
      {{ "knowledge_base.preferred_products.col.last_update" | translate }}
      <div class="list-preferred-products__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'last_seen_date' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'last_seen_date' && sortMode === 'desc'"></span>
      </div>
    </div>
  </div>

  <!-- Scrollable body -->
  <div class="list-preferred-products__table-body">
    <!-- Loading state -->
    <div class="list-preferred-products__loading" *ngIf="loading$ | async">
      <div class="list-preferred-products__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(loading$ | async) && sortedPreferredProducts.length > 0">
      <div
        *ngFor="let item of sortedPreferredProducts"
        class="list-preferred-products__table-row"
        [class.is-not-editable]="!canEdit(item)"
        [matTooltip]="canEdit(item) ? '' : ('knowledge_base.preferred_products.actions.edit_tooltip_disabled' | translate)"
        matTooltipPosition="above"
        (click)="openEditModal(item)"
      >
        <div class="list-preferred-products__table-cell list-preferred-products__table-cell--checkbox" (click)="$event.stopPropagation()">
          <ui-checkbox
            [checked]="selection.isSelected(item.id)"
            [ariaLabel]="'common.select' | translate"
            (changed)="selection.toggleOne(item.id, $event.checked, $event)"
          ></ui-checkbox>
        </div>
        <div class="list-preferred-products__table-cell">{{ item.customer_name || "--" }}</div>
        <div class="list-preferred-products__table-cell">{{ item.product_name || "--" }}</div>
        <div class="list-preferred-products__table-cell">{{ item.sku || "--" }}</div>
        <div class="list-preferred-products__table-cell">{{ item.purchase_frequency }}</div>
        <div class="list-preferred-products__table-cell">
          <ng-container *ngIf="item.source === 'manual'">
            <span class="list-preferred-products__source-badge list-preferred-products__source-badge--manual">
              {{ "knowledge_base.preferred_products.source.manual" | translate }}
            </span>
          </ng-container>
          <ng-container *ngIf="item.source === 'import'">
            <span class="list-preferred-products__source-badge list-preferred-products__source-badge--import">
              {{ "knowledge_base.preferred_products.source.import" | translate }}
            </span>
          </ng-container>
          <ng-container *ngIf="item.source === 'order'">
            <a
              *ngIf="item.source_order_id"
              class="list-preferred-products__order-link"
              [routerLink]="['/quotations', item.source_order_id]"
              (click)="$event.stopPropagation()"
            >
              {{ item.source_order_ref || ("knowledge_base.preferred_products.source.order" | translate) }}
            </a>
            <span *ngIf="!item.source_order_id" class="list-preferred-products__source-badge list-preferred-products__source-badge--order">
              {{ "knowledge_base.preferred_products.source.order" | translate }}
            </span>
          </ng-container>
        </div>
        <div class="list-preferred-products__table-cell">{{ item.create_date ? (item.create_date | date: "dd/MM/yyyy") : "--" }}</div>
        <div class="list-preferred-products__table-cell">{{ item.last_seen_date ? (item.last_seen_date | date: "dd/MM/yyyy") : "--" }}</div>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div *ngIf="sortedPreferredProducts.length === 0 && !(loading$ | async)" class="list-preferred-products__empty">
      <ng-container *ngIf="!keyword && !hasActiveFilters()">
        <img class="list-preferred-products__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.preferred_products.empty_state" | translate }}</h3>
      </ng-container>
      <ng-container *ngIf="keyword || hasActiveFilters()">
        <img class="list-preferred-products__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.preferred_products.empty_state_search" | translate }}</h3>
      </ng-container>
    </div>
  </div>

  <!-- ───────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ───────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar
    *ngIf="selection.hasSelection"
    [count]="selection.count"
    (cleared)="selection.clear()"
  >
    <button
      *appHasPermission="{ module: 'knowledge_base', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()"
    >
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination
    *ngIf="sortedPreferredProducts.length > 0"
    class="list-preferred-products__pagination"
    [pagination]="metadata$ | async"
    (toPageEvent)="toPage($event)"
  ></app-pagination>
</div>
